import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import config from "../../config";
import "./ForgotPass.css";
import Loader from "../../components/loader/loader";
import logo from "../../assets/images/RedP_LogoT.png";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setIsSuccess(false);

    try {
      const url = `${config.REACT_APP_API_URL}/auth/reset-password`;
      const payload = {
        token,
        new_password: password,
      };

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setIsSuccess(true);
        setMessage(data.message || "Password reset successful!");
        setTimeout(() => navigate("/"), 2000);
      } else {
        setMessage(data.message || "Failed to reset password.");
      }
    } catch (err) {
      setMessage("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fp-page-container">
        <div className="fp-card">
            
            {/* --- LEFT PANEL: Information --- */}
            <div className="fp-info-section">
                <img src={logo} alt="RedP Logo" className="fp-sidebar-logo" />
                
                <div className="fp-info-content">
                    <h2>Secure Reset</h2>
                    <p>You are creating a new password for your RedP account.</p>
                    <p>For your security, we recommend:</p>
                    <ul className="fp-instruction-list">
                        <li>Using a mix of letters, numbers, and symbols.</li>
                        <li>Avoiding common words or personal dates.</li>
                        <li>Making it distinct from passwords used on other sites.</li>
                    </ul>
                </div>

                <Link to="/" className="fp-back-link">
                    <span>←</span> Back to Sign In
                </Link>
            </div>

            {/* --- RIGHT PANEL: Form --- */}
            <div className="fp-auth-section">
                <h1>Reset Password</h1>
                <p className="fp-subtitle">Please enter your new password below.</p>

                <form className="fp-form" onSubmit={handleSubmit}>
                    <input
                    type="password"
                    placeholder="New password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                    aria-label="New Password"
                    />
                    
                    <button type="submit" disabled={loading}>
                        {loading ? "Updating..." : "Set New Password"}
                    </button>
                </form>

                {loading && (
                    <div style={{ marginTop: '1rem' }}><Loader text="Updating..."/></div>
                )}

                {message && (
                    <div className={`fp-message ${isSuccess ? "success" : "error"}`}>
                        {message}
                    </div>
                )}
            </div>
        </div>
    </div>
  );
}
